import Input from "../General/Input"
import Accordian from "../General/Accordian"
import FAQs from "../../constants/FAQs"
import { Tabs } from "../../constants/FAQs"
import { useState, forwardRef } from "react"

function FAQsSection(props : any, ref : any) {
    const [searchString, setSearchString] = useState('');
    const [currentTab, setCurrentTab] = useState(() => 'general')
    const [dataList, setDataList] : any = useState(() => {
        return FAQs.filter((FAQ : any) => FAQ.category === currentTab);
    });

    const searchQuestions = (event : any) => {    
        setSearchString(event.target.value);
        let results : any = []
        FAQs.forEach((data : any) => {  
            const lowerStringQuestion = data.question.toLowerCase();
            if(lowerStringQuestion.includes(event.target.value.toLowerCase())) {
                results = [...results, ...[data]]
            }
        });
        setDataList(results);
    }

    const filterByCategory = (tab : string) => {
        setDataList(() => {
            return FAQs.filter((FAQ : any) => FAQ.category === tab);
        })
        setCurrentTab(() => tab);
    }
    
    return (
        <div id="FAQ-section" className="">
            <div className="flex flex-col flex-col-reverse text-theme-black lg:flex-row lg:justify-between">
                <div className="flex overflow-x-auto mt-4 lg:mt-0 lg:w-[60%]">
                    {
                        Tabs.map((tab : string) => (
                            <div 
                                className={`
                                    cursor-pointer
                                    text-[20px]
                                    capitalize 
                                    mr-4 
                                    pb-4 
                                    pt-2 
                                    px-2
                                    lg:px-4
                                    ${tab === currentTab && 'border-t-[3px] border-theme-orange'}
                                    ${tab === currentTab ? 'text-theme-orange' : 'text-theme-dark-saffron'}
                                    ` 
                                }
                                style={{ background : tab === currentTab ? 'rgba(229, 233, 241, 0.4)' : 'none' }}
                                onClick={() => filterByCategory(tab)}
                                key={tab}
                                >
                                {tab}
                            </div>
                        ))
                    }
                </div>

                <div className="lg:w-[30%] lg:mb-3">
                    <Input
                        placeholder="Have questions? We're here to help"
                        outerProperties="border py-2 rounded"
                        suffix={
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7 text-[gray] mx-3 border-l pl-2">
                                <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z" clipRule="evenodd" />
                            </svg>
                        }
                        value = {searchString}
                        onChange = {searchQuestions}
                    />
                </div>
            </div>
            <div className="px-3 py-3 lg:px-[20px] h-[430px] overflow-y-auto" style={{ background : 'rgba(229, 233, 241, 0.4)' }}>
                {
                    dataList.map((data : any, index : any) => (
                        <div className='' key={index}>
                            <Accordian data={data} />
                        </div>
                    ))
                }
            </div>
            {
                dataList.length === 0 && 
                <p className="text-[gray] text-center">No Results!</p>
            }
        </div>
    )
}

export default forwardRef(FAQsSection)